import { LISTINGS_TABLE_SALE_TYPES } from 'Services/dynamoDb/dynamoDb.const';
import type { ListingsTableSaleType } from 'Services/dynamoDb/dynamoDb.types';
import {
	useGetBuyItNowAdditionalVehicleDetailsById,
	useGetLiveSaleAdditionalVehicleDetailsById,
} from 'Stores/AdditionalVehicleDetailsStore/AdditionalVehicleDetailsStore';

type UseGetAdditionalVehicleDetailsParams = {
	id: string | number;
	saleType?: ListingsTableSaleType;
};

export const useGetAdditionalVehicleDetails = ({ id, saleType }: UseGetAdditionalVehicleDetailsParams) => {
	const getBuyItNowAdditionalVehicleDetailsById = useGetBuyItNowAdditionalVehicleDetailsById(id);
	const getLiveSaleAdditionalVehicleDetailsById = useGetLiveSaleAdditionalVehicleDetailsById(id);

	switch (saleType) {
		case LISTINGS_TABLE_SALE_TYPES.buyItNow:
			return getBuyItNowAdditionalVehicleDetailsById;
		case LISTINGS_TABLE_SALE_TYPES.liveSale:
			return getLiveSaleAdditionalVehicleDetailsById;
		default:
			return {};
	}
};
